import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useGetTaxReports } from '@/query/queries/activity/useGetTaxReports';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { Preloader } from '@/components/Preloader';
import { ACCOUNT_TYPES } from '@/helpers/constants';
import { DesktopView } from './desktop';
import s from './index.module.scss';

export const DataView = ({ params }) => {
  const { type: accountType } = useOutletContext();
  const { data, isLoading } = useGetTaxReports({
    date_from: params.range[0],
    date_to: params.range[1],
    type: accountType,
  });

  const isEmpty = useMemo(() => {
    if (!data || !accountType) return true;

    if (accountType === ACCOUNT_TYPES.personal && (data.fees || data.net_proceeds || data.sale_proceeds))
      return false;

    if (accountType === ACCOUNT_TYPES.business && (data.interest_expense || data.platform_fees))
      return false;

    return true;
  }, [data, accountType]);

  return (
    <div className={s.wrapper}>
      {isLoading ? (
        <Preloader style={{ height: '30vh' }} />
      ) : isEmpty ? (
        <div className={s.empty}>
          <EmptyContent />
        </div>
      ) : (
        <DesktopView type={accountType} data={data} />
      )}
    </div>
  );
};
